import React from 'react';
import '../Dashboard/Tracker/Tracker.css';
import '../Dashboard/Tracker/DailyActions/DailyActions.css';
import '../Dashboard/Tracker/ActionSteps/ActionStep.css';
import { demoDashboardState } from './marketingDemoData';

const circlePath = `M18 2.0845
a 15.9155 15.9155 0 0 1 0 31.831
a 15.9155 15.9155 0 0 1 0 -31.831`;

/** Static V1 Action Tracker — Daily Actions tab for marketing. */
const MarketingTrackerPreview = ({ activeTab = 'daily' }) => (
    <article className="tracker marketing-tracker">
        <div className="TitleDashboardContent">
            <p className="heading-5 BlueDarkText">MY ACTION TRACKER</p>
        </div>
        <ul className="myActionTrackerTabsContainer TitleMyGoal">
            <li>
                <button
                    type="button"
                    className={`firstTabMyGoal${
                        activeTab === 'tracker' ? ' activeTabTacker' : ''
                    }`}
                >
                    TRACKER
                </button>
            </li>
            <li>
                <button
                    type="button"
                    className={activeTab === 'daily' ? 'activeTabTacker' : ''}
                >
                    DAILY ACTIONS
                </button>
            </li>
            <li>
                <button type="button">TO-DO LIST</button>
            </li>
        </ul>
        <section className="MyTrackerSection__Container">
            {activeTab === 'tracker' ? (
                <div className="tracker__container">
                    <article className="oolaButton">
                        <div className="oolaButton__svgButton">
                            <svg
                                viewBox="22 0 200 200"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden
                            >
                                <g transform="scale(.9) translate(10 -10)">
                                    <g transform="translate(43,24)">
                                        <g
                                            style={{
                                                transform: 'rotate(2deg) scale(5)',
                                            }}
                                        >
                                            <path
                                                className="circleInactive"
                                                strokeDasharray="31,100"
                                                d={circlePath}
                                                strokeWidth="100px"
                                            />
                                            <path
                                                className="circle"
                                                strokeDasharray="31, 100"
                                                d={circlePath}
                                                strokeWidth="100px"
                                            />
                                        </g>
                                    </g>
                                </g>
                                <circle
                                    fill="transparent"
                                    r="88"
                                    cx="123"
                                    cy="97"
                                    stroke="white"
                                    strokeWidth="4px"
                                />
                                <circle
                                    className="btnTracker shadow"
                                    cx="123"
                                    cy="97"
                                    fill="#d86b59"
                                    r="51"
                                />
                                <text
                                    x="123"
                                    y="92"
                                    textAnchor="middle"
                                    fill="#fff"
                                    fontSize="28"
                                    fontWeight="bold"
                                >
                                    {demoDashboardState.DailySteps}
                                </text>
                                <text
                                    x="123"
                                    y="112"
                                    textAnchor="middle"
                                    fill="#fff"
                                    fontSize="10"
                                >
                                    TODAY
                                </text>
                            </svg>
                        </div>
                        <p className="paragraph-2 oolaButton__stepsTaken">
                            <span>{demoDashboardState.AllSteps.toLocaleString()}</span>
                            <br />
                            LIFETIME ACTION STEPS
                        </p>
                    </article>
                </div>
            ) : (
                <section className="modalActions__section DailyActions__container">
                    <div className="DailyActionsSelectedDay__container">
                        Today
                    </div>
                    <div className="modalActions__sectionComplete DailyActions">
                        <div>
                            <h6 className="heading-6">COMPLETE</h6>
                        </div>
                    </div>
                    {demoDashboardState.Actions.filter((a) => a.text).map(
                        (item, index) => (
                            <article
                                key={item.id || index}
                                className={`actionSteps${
                                    index === 0 ? ' firstItem' : ''
                                }`}
                            >
                                <div className="actionSteps__number">
                                    <h3 className="heading-3">{index + 1}</h3>
                                </div>
                                <div className="actionSteps__input">
                                    <input
                                        readOnly
                                        value={item.text}
                                        aria-label={item.text}
                                    />
                                </div>
                                <div className="actionSteps__radio actionSteps__button">
                                    {item.id != null ? (
                                        <input
                                            type="radio"
                                            readOnly
                                            aria-label="Complete action"
                                        />
                                    ) : null}
                                </div>
                            </article>
                        )
                    )}
                </section>
            )}
        </section>
    </article>
);

export default MarketingTrackerPreview;
